import { render, staticRenderFns } from "./HaabTasks.vue?vue&type=template&id=79a2d8a1&scoped=true"
import script from "./HaabTasks.vue?vue&type=script&lang=js"
export * from "./HaabTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2d8a1",
  null
  
)

export default component.exports